import React, { useState, useEffect } from "react";
import {
	clearLocalStorage,
	getDataFromJwt,
	isAdmin,
	isUser,
	isVolunteer,
	replaceIdInUrl,
	toastMaker,
} from "../../utils/utility";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Popup from "../section/popup";
import matrimonyInstance from "../../utils/axios";
import {
	CHANGE_PASSSWORD,
	LIST_MY_PROFILES,
	RESET_PASSWORD,
} from "../../API_LIST";
import ROLES from "../../utils/constants";
import { setCurrentProfile } from "../../redux/features/authSlice";
import { setPaymentVisible } from "../../redux/features/paymentSlice";
import { useSearchParams } from "react-router-dom";

export default function DashboardHeader() {
	const [name, setName] = useState(getDataFromJwt("first_name"));
	const [modalIsOpen, setIsOpen] = useState(false);
	const [changePasswordIsOpen, setChangePasswordIsOpen] = useState(false);
	const [newPassword, setNewPassword] = useState("");
	const [currentPassword, setCurrentPassword] = useState("");
	const [showCurrentPassword, setShowCurrentPassword] = useState(false);
	const [confirmPassword, setConfirmPassword] = useState("");
	const [showNewPassword, setShowNewPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);
	const [passwordsMatch, setPasswordsMatch] = useState(true);

	const [profilesData, setProfilesData] = useState();
	const [searchProfileId, setSearchProfileId] = useState();
	const disPatch = useDispatch();
	const navigate = useNavigate();
	const roleId = getDataFromJwt("role");
	const selectedProfile = useSelector((state) => state.auth.currentProfile);

	const roleid = getDataFromJwt("role");

	function getParent() {
		if (roleid) {
			return ROLES[roleid].landingUrl;
		}
	}
	const parent = getParent();

	const getUserProfiles = () => {
		let userId = getDataFromJwt("id");
		if (isUser()) {
			let url = replaceIdInUrl(LIST_MY_PROFILES, userId);
			matrimonyInstance.get(url).then((response) => {
				let objectIs = response.data;
				if (!selectedProfile) switchProfile(JSON.stringify(objectIs[0]));
				setProfilesData(objectIs);
			});
		}
	};

	useEffect(() => {
		getUserProfiles();
	}, []);

	function switchProfile(profile) {
		if (!profile) return;
		disPatch(setCurrentProfile(profile));
		setIsOpen(false);
	}

	function closeModal() {
		setIsOpen(false);
	}

	const htmlPopup =
		isUser() && selectedProfile ? (
			<div
				className="d-flex flex-column align-items-center mt-25 bg-dashboard"
				style={{ width: "90%", height: "790px", borderRadius: "8px" }}
			>
				<h5 className="mb-20 mt-20">Switch your profile</h5>
				<div className="profile-card-list pop-up-scrollbar">
					{profilesData?.profiles?.map((item, index) => (
						<div
							className={`profile-card cursor-pointer ${
								selectedProfile.profile_id === item.profile_id
									? "active-profile"
									: null
							} `}
							key={index}
							onClick={() => switchProfile(item)}
						>
							<div className="d-flex gap-4 pt-10">
								<img
									src={
										item?.profile === "groom"
											? "../../assets/images/bat-img/profile-male.svg"
											: "../../assets/images/bat-img/profile-female.svg"
									}
									className="user-image"
									alt="Profile"
								/>
								<div>
									<div className="d-flex gap-3 mb-15">
										<h5 className="tetx-blue-card">
											{item?.first_name} {item?.last_name}
										</h5>
										{item.profile_verification_status == "in_progress" ? (
											<img
												title="Pending verification"
												src="../../assets/images/bat-img/status-pending.svg"
											/>
										) : null}
										{item.profile_verification_status == "approved" ? (
											<img
												title="Verified profile"
												src="../../assets/images/bat-img/status-approved.svg"
											/>
										) : null}
										{item.profile_verification_status == "rejected" ? (
											<img
												title="Rejected profile"
												src="../../assets/images/bat-img/status-rejected.svg"
											/>
										) : null}
										{item.payment_status === "unpaid" ? (
											<img
												title="Pending payment"
												src="../../assets/images/bat-img/payment-pending.svg"
											/>
										) : item.payment_status === "expired" ? (
											<img
												title="Expired payment"
												src="../../assets/images/bat-img/payment-pending.svg"
											/>
										) : (
											<img
												title="Paid profile"
												src="../../assets/images/bat-img/payment-done.svg"
											/>
										)}
									</div>
									<div className="d-flex gap-3 mb-10 font-14">
										<img src="../../assets/images/bat-img/profile-job.svg" />
										<span>{item?.profession}</span>
									</div>
									<div className="d-flex gap-3 font-14">
										<img src="../../assets/images/bat-img/profile-location.svg" />
										<span className="fw-600">{item?.current_location}</span>
									</div>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		) : null;

	useEffect(() => {
		setPasswordsMatch(
			newPassword === confirmPassword || confirmPassword === "",
		);
	}, [newPassword, confirmPassword]);

	const changePassword = async (e) => {
		e.preventDefault();
		if (!currentPassword || !newPassword || !confirmPassword) {
			toastMaker("Please fill out both password fields", "error");
			return;
		}
		if (!passwordsMatch) {
			toastMaker("Passwords do not match!", "error");
			return;
		}

		try {
			const response = await matrimonyInstance.post(CHANGE_PASSSWORD, {
				old_password: currentPassword,
				new_password: newPassword,
				account_id: getDataFromJwt("id"),
			});

			if (response.status === 200) {
				toastMaker("Password changed ", "success");
				setChangePasswordIsOpen(false);
				setCurrentPassword("");
				setConfirmPassword("");
				setNewPassword("");
			} else {
				toastMaker("Failed to reset password. Try again.", "error");
			}
		} catch (error) {
			toastMaker("Error resetting password", "error");
		}
	};
	return (
		<React.Fragment>
			<div className="header">
				<div style={{ display: "flex", justifyContent: "space-between" }}>
					<div className="username">
						<img
							src="../../assets/images/bat-img/Group-139.svg"
							alt="BAT Logo"
							className="logo-group"
						/>
						<p>{ROLES[roleId]?.name}</p>
					</div>
					<img
						src="../../assets/images/bat-img/bat-logo-1.png"
						alt="BAT Logo"
						className="logo ml-50 cursor-pointer"
						onClick={() => navigate("/")}
					/>
				</div>
				<div className="search-bar-group">
					{isUser() &&
					selectedProfile?.first_name &&
					selectedProfile?.last_name ? (
						<div
							className="switch-profile-group"
							onClick={() => {
								setIsOpen(true);
								disPatch(setPaymentVisible(false));
							}}
						>
							<p>
								<b>Selected Profile:</b> {selectedProfile?.first_name}{" "}
								{selectedProfile?.last_name}{" "}
							</p>
							<img
								src="../../assets/images/bat-img/switch-profile.svg"
								alt="profile-switch"
								title="Switch profile"
								onClick={() => {
									getUserProfiles();
								}}
							/>
						</div>
					) : null}
					{/* <img
          src="../../assets/images/bat-img/profile-search-icon.svg"
          alt="BAT Logo"
        />
         */}
					{isAdmin() || isVolunteer() ? (
						<>
							{" "}
							<input
								type="text"
								className="form-control shadow-none"
								placeholder="Search by profile id"
								onChange={(e) => setSearchProfileId(e.target.value)}
							/>
							<button
								className="text-white"
								onClick={(e) => (
									navigate("./view-profile/" + searchProfileId), navigate(0)
								)}
							>
								GO
							</button>
						</>
					) : null}
				</div>
				<div className="dropdown">
					<div className="profile-group dropbtn">
						<img
							src="../../assets/images/bat-img/profile.svg"
							alt="BAT Logo"
							className="profile-icon"
						/>
						<p>{name}</p>
						<img
							src="../../assets/images/bat-img/profile-dropdown-icon.svg"
							alt="BAT Logo"
							className="profile-dropdown-icon"
						/>
					</div>
					<div className="dropdown-content">
						{isUser() ? <Link to="./account">My Account</Link> : null}

						<Link onClick={() => setChangePasswordIsOpen(true)}>
							Change Password
						</Link>
						{/*
            <Link to="/dashboard/profile">Saved profiles</Link> */}
						<a href="#" onClick={clearLocalStorage}>
							Logout
						</a>
					</div>
				</div>
			</div>
			{isUser() ? (
				<Popup
					modalIsOpen={modalIsOpen}
					closeModal={closeModal}
					html={htmlPopup}
				/>
			) : null}
			<Popup
				modalIsOpen={changePasswordIsOpen}
				closeModal={() => setChangePasswordIsOpen(false)}
				// style={customStyles}
				contentLabel="Change password"
				html={
					<div className="container">
						<div className="login-section padding-tb">
							<div className="row align-items-center">
								<div className="account-container">
									<div className="d-flex gap-5">
										<h3 className="account-title cursor-pointer">
											Change Password
										</h3>
									</div>
									<form onSubmit={changePassword}>
										<div className="row justify-content-between">
											<div className="col-12 col-lg-7 col-sm-12">
												<div className="account-wrapper">
													<div className="account-form">
														<div className="row mt-20 justify-content-center">
															<div className="col-lg-12 col-sm-12 col-12 px-3">
																<div className="form-group">
																	<div className="input-title">
																		Current Password
																	</div>
																	<div className="input-field position-relative">
																		<input
																			type={
																				showCurrentPassword
																					? "text"
																					: "password"
																			}
																			placeholder="Enter current password"
																			className="with-icon input-icon"
																			name="newPassword"
																			value={currentPassword}
																			onChange={(e) =>
																				setCurrentPassword(e.target.value)
																			}
																		/>
																		<div className="login-icon">
																			<img
																				src="../assets/images/bat-img/login-password.svg"
																				alt="password icon"
																			/>
																		</div>
																		<div
																			className="password-visible-icon"
																			onClick={() =>
																				setShowCurrentPassword(
																					!showCurrentPassword,
																				)
																			}
																		>
																			{showCurrentPassword ? (
																				<svg
																					xmlns="http://www.w3.org/2000/svg"
																					fill="none"
																					viewBox="0 0 24 24"
																					strokeWidth={1.5}
																					stroke="currentColor"
																					className="size-6"
																				>
																					<path
																						strokeLinecap="round"
																						strokeLinejoin="round"
																						d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
																					/>
																					<path
																						strokeLinecap="round"
																						strokeLinejoin="round"
																						d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
																					/>
																				</svg>
																			) : (
																				<svg
																					xmlns="http://www.w3.org/2000/svg"
																					fill="none"
																					viewBox="0 0 24 24"
																					strokeWidth={1.5}
																					stroke="currentColor"
																					className="size-6"
																				>
																					<path
																						strokeLinecap="round"
																						strokeLinejoin="round"
																						d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
																					/>
																				</svg>
																			)}
																		</div>
																	</div>
																</div>
															</div>
															<div className="col-lg-12 col-sm-12 col-12 px-3">
																<div className="form-group">
																	<div className="input-title">
																		New Password
																	</div>
																	<div className="input-field position-relative">
																		<input
																			type={
																				showNewPassword ? "text" : "password"
																			}
																			placeholder="Enter new password"
																			className="with-icon input-icon"
																			name="newPassword"
																			value={newPassword}
																			onChange={(e) =>
																				setNewPassword(e.target.value)
																			}
																		/>
																		<div className="login-icon">
																			<img
																				src="../assets/images/bat-img/login-password.svg"
																				alt="password icon"
																			/>
																		</div>
																		<div
																			className="password-visible-icon"
																			onClick={() =>
																				setShowNewPassword(!showNewPassword)
																			}
																		>
																			{showNewPassword ? (
																				<svg
																					xmlns="http://www.w3.org/2000/svg"
																					fill="none"
																					viewBox="0 0 24 24"
																					strokeWidth={1.5}
																					stroke="currentColor"
																					className="size-6"
																				>
																					<path
																						strokeLinecap="round"
																						strokeLinejoin="round"
																						d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
																					/>
																					<path
																						strokeLinecap="round"
																						strokeLinejoin="round"
																						d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
																					/>
																				</svg>
																			) : (
																				<svg
																					xmlns="http://www.w3.org/2000/svg"
																					fill="none"
																					viewBox="0 0 24 24"
																					strokeWidth={1.5}
																					stroke="currentColor"
																					className="size-6"
																				>
																					<path
																						strokeLinecap="round"
																						strokeLinejoin="round"
																						d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
																					/>
																				</svg>
																			)}
																		</div>
																	</div>
																</div>
															</div>

															<div className="col-lg-12 col-sm-12 col-12 px-3">
																<div className="form-group">
																	<div className="input-title">
																		Confirm Password
																	</div>
																	<div className="input-field position-relative">
																		<input
																			type={
																				showConfirmPassword
																					? "text"
																					: "password"
																			}
																			placeholder="Confirm your password"
																			className="with-icon input-icon"
																			name="confirmPassword"
																			value={confirmPassword}
																			onChange={(e) =>
																				setConfirmPassword(e.target.value)
																			}
																		/>
																		<div className="login-icon">
																			<img
																				src="../assets/images/bat-img/login-password.svg"
																				alt="password icon"
																			/>
																		</div>
																		<div
																			className="password-visible-icon"
																			onClick={() =>
																				setShowConfirmPassword(
																					!showConfirmPassword,
																				)
																			}
																		>
																			{showConfirmPassword ? (
																				<svg
																					xmlns="http://www.w3.org/2000/svg"
																					fill="none"
																					viewBox="0 0 24 24"
																					strokeWidth={1.5}
																					stroke="currentColor"
																					className="size-6"
																				>
																					<path
																						strokeLinecap="round"
																						strokeLinejoin="round"
																						d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
																					/>
																					<path
																						strokeLinecap="round"
																						strokeLinejoin="round"
																						d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
																					/>
																				</svg>
																			) : (
																				<svg
																					xmlns="http://www.w3.org/2000/svg"
																					fill="none"
																					viewBox="0 0 24 24"
																					strokeWidth={1.5}
																					stroke="currentColor"
																					className="size-6"
																				>
																					<path
																						strokeLinecap="round"
																						strokeLinejoin="round"
																						d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
																					/>
																				</svg>
																			)}
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div className="account-bottom1 text-center">
														<button
															className="button login-btn create-btn text-white"
															onClick={changePassword}
														>
															Change Password
														</button>
													</div>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				}
			></Popup>
		</React.Fragment>
	);
}
